import { render, staticRenderFns } from "./WarehouseList.vue?vue&type=template&id=2d12cb35"
import script from "./WarehouseList.vue?vue&type=script&lang=js"
export * from "./WarehouseList.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/app/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('2d12cb35')) {
      api.createRecord('2d12cb35', component.options)
    } else {
      api.reload('2d12cb35', component.options)
    }
    module.hot.accept("./WarehouseList.vue?vue&type=template&id=2d12cb35", function () {
      api.rerender('2d12cb35', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/warehouse/WarehouseList.vue"
export default component.exports